import { Route, redirect } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';
import { isFeatureEnabled } from '@apply/store/src/user/types.ts';
import { hasPermission } from '@apply/ui';
import { FeatureType, PermissionType, WatchlistSummaryType } from '@apply/constants';
import store from '@apply/adminStore';

import WatchlistsSummary from '../../../watchlists/WatchlistsSummary';
import WatchlistBySummaryType from '../../../watchlists/WatchlistBySummaryType';

function watchlistsLoader() {
    const { user } = store.getState();
    if (!isFeatureEnabled(user, FeatureType.Watchlists) || !hasPermission(PermissionType.WatchlistView)) {
        return redirect('/adminreferral');
    }
    return null;
}

export default function WatchlistRoutes() {
    return (
        <>
            <Route
                path='/watchlists'
                loader={watchlistsLoader}
                element={
                    <RequireAdmin>
                        <WatchlistsSummary />
                    </RequireAdmin>
                }
            />
            <Route
                path='/watchlists/vertical'
                loader={watchlistsLoader}
                element={
                    <RequireAdmin>
                        <WatchlistBySummaryType
                            summaryTypeId={WatchlistSummaryType.Vertical}
                            title='Vertical Watchlist'
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/watchlists/rentals'
                loader={watchlistsLoader}
                element={
                    <RequireAdmin>
                        <WatchlistBySummaryType
                            summaryTypeId={WatchlistSummaryType.Rentals}
                            title='Rentals Watchlist'
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/watchlists/sba'
                loader={watchlistsLoader}
                element={
                    <RequireAdmin>
                        <WatchlistBySummaryType
                            summaryTypeId={WatchlistSummaryType.SBA}
                            title='SBA Watchlist'
                        />
                    </RequireAdmin>
                }
            />
        </>
    );
}
